import api from "./api";
import { ISetModulocker } from "config/interfaces";
// import { randomBytes, randomInt } from "crypto";

interface Set {
  IDMCM: number;
  DSMCM: string;
}

const getAllShort = (IDSITE: string = "") => {
  return api.get<Set[]>(`/api_front/MCMSiteSearch/${IDSITE}`);
};

const getAll = (params?: ISetModulocker.ParamsQuery) => {
  return api.patch<ISetModulocker.Set[]>(`/api_front/MCMSearch`, params);
};

const getOne = (IDMCM: string) => {
  return api.patch<ISetModulocker.Set[]>(`/api_front/MCMSearch`, { IDMCM });
};

const boxesStatus = (setId: string) => {
  return api.get<ISetModulocker.SetInformation>(
    `/api_front/MCMSStatus/${setId}`
  );
};

const boxList = (IDMCM: string) => {
  return api.get(`/api_front/MCMBox/${IDMCM}`);
}

const getCharts = (setId: string) => {
  return api.get(`/api_front/MCMChart/${setId}`);
};

const getComplements = (setId: string) => {
  return api.get<ISetModulocker.Complements[]>(
    `/api_front/complSearch/1/${setId}`
  );
};

const getControlPanelOne = async (IDMCM: string) => {
  const result = await api.get<ISetModulocker.ControlPanel>(
    `/api_front/MCMControlPanel/${IDMCM}`
  );
  return result;
};

const getListUserGroupsBySet = (IDMCM: number) => {
  return api.patch<ISetModulocker.UserGroup[]>(
    `/api_front/GroupUserMCMSearch`,
    { IDMCM }
  );
};

const getEvents = (IDMCM: string) => {
  return api.get(`/api_front/MCMEvents/${IDMCM}`);
};

const sendTurnOffSirene = (IDMCM: string) => {
  const body = {
    tid: Math.round(Math.random() * 65536),
    action: 4,
    args: {
      command: 0,
    },
  };

  return api.post<ISetModulocker.ActionSiren>(
    `/api_front/MCMSilenceSiren/${IDMCM}`,
    { body }
  );
};

export {
  getControlPanelOne,
  getAll,
  getAllShort,
  boxesStatus,
  boxList,
  getCharts,
  getComplements,
  getOne,
  getListUserGroupsBySet,
  sendTurnOffSirene,
  getEvents,
};
